import React, { Component } from 'react';
import { Form, Card, Button, Col, Nav, Table, Alert, Navbar, Container, Row } from 'react-bootstrap';

// import errores from '../../middleware/errordb'

import config from '../../config';
import Mensajes from '../subcomponent/mensajes';
import ModalConfirm from '../subcomponent/modalConfirm';
import SearchEmployee from '../subcomponent/searchEmployee'
import moment from 'moment';
import { Fragment } from 'react';
import DetailPayrollModal from './subcomponents/detailPayrollModal';
import { concepts_payroll } from './localdata/conceptos';
import { IconContext } from 'react-icons';
import { IoIosRemoveCircle } from 'react-icons/io';
import TitleModule from '../widgets/module_title';
import BackButton from '../widgets/back_button';

class FormularioParametros extends Component {
    currentCompany = sessionStorage.getItem('company');
    currentUserType = sessionStorage.getItem('tipo');
    constructor(props) {
        super(props);

        this.initDateRef = React.createRef();
        this.finalDateRef = React.createRef();
        //const usuarioMofificar = this.props

        const today = new Date();
        const dd = String(today.getDate()).padStart(2, '0');
        const mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!mm
        const yyyy = today.getFullYear();
        const fecha = yyyy + "-" + mm + "-" + dd;
        this.state = {
            titulo: "Crear Parametros",
            mostrarMensaje: false,
            msg: 0,
            comp: "",
            tipo: this.currentUserType,
            id: "",
            id_parametro: "",
            SUELDO_EMPLEADO: "",
            PORCENTAJE_PENSION: 0,
            PORCENTAJE_SALUD: 0,
            PORCENTAJE_CESANTIAS: 0,
            SALARIO_INTEGRAL: 0,
            //CABECERA
            ID_EMPRESA: this.currentCompany,
            ID_EMPLEADO: "",
            NOMBRE_EMPLEADO: "",
            DOCUMENTO_EMPLEADO: "",
            DIRECCION_EMPLEADO: "",
            CIUDAD_EMPLEADO: "",
            BANCO_EMPLEADO: "",
            TIPO_DOCUMENTO_NOMINA: "NE",
            TIPO_CUENTA_EMPLEADO: "",
            NUMERO_CUENTA_EMPLEADO: "",
            NUMERO_DOCUMENTO_NOMINA: 0,
            fecha_hoy: fecha,
            DOCUMENTO_RELACION: "",
            AJUSTE: false,
            USAR_NORMA_LEY_EMPLEADO: 1,
            numeroDocNomina: 0,
            showAlert: false,
            empleados: [],
            parametros: [],
            documentos: [],
            detalle_nomina: [],
            tipo_usuario: "",
            buttonmsg: "",
            mensaje: "",
            checkT: true,
            variant: '',
            alertmessage: '',
            COTIZA_PENSION: 0,
            TOTAL_TIEMPO_DEVENGADO: 0,
        }
    }

    componentDidMount() {
        this.initNomina();
    }

    initNomina = () => {
        const datasend = {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'empresa': this.state.ID_EMPRESA,
            }
        }
        fetch(config.servBackEnd + '/payroll/' + this.state.ID_EMPRESA, datasend).then(response => response.json())
            .then(data => {
                if (data.ok) {
                    const cData = data.data;
                    const empleados = cData[0];
                    const parametros = cData[1];
                    const empresa = cData[2];
                    const documentos = cData[3];
                    const TIPO_DOCUMENTO_NOMINA = (cData[4][0]) ? cData[4][0]["PREFIJO"] : "NE";
                    this.setState({
                        empleados,
                        parametros,
                        documentos,
                        TIPO_DOCUMENTO_NOMINA,
                        VALOR_SMLV: parametros[0]["VALOR_SMLV"],
                        DIRECCION_EMPRESA: empresa[0]["DIRECCION"],
                        TELEFONO_EMPRESA: empresa[0]["TELEFONO"],
                        AUX_TRANSPORTE: parametros[0]["AUX_TRANSPORTE"],
                        PORCENTAJE_PENSION: parametros[0]["PORCENTAJE_PENSION"],
                        PORCENTAJE_SALUD: parametros[0]["PORCENTAJE_SALUD"],
                        PORCENTAJE_CESANTIAS: parametros[0]["PORCENTAJE_CESANTIAS"]
                    });

                } else {
                    // console.log("La información no está ok");
                }
            });
    }

    selectEmployee = (employee) => {
        const value = employee.ID_EMPLEADO;
        if (value) {
            this.setState({
                DOCUMENTO_EMPLEADO: employee.DOCUMENTO_EMPLEADO,
                NOMBRE_EMPLEADO: employee.NOMBRE_COMPLETO,
                DIRECCION_EMPLEADO: employee.DIRECCION_EMPLEADO,
                CIUDAD_EMPLEADO: employee.CODIGO_MUNICIPIO_EMPLEADO,
                BANCO_EMPLEADO: employee.BANCO,
                TIPO_CUENTA_EMPLEADO: employee.TIPO_CUENTA,
                NUMERO_CUENTA_EMPLEADO: employee.NUMERO_CUENTA,
                ID_EMPLEADO: employee.ID_EMPLEADO,
                SUELDO_EMPLEADO: employee.SUELDO_EMPLEADO,
                SALARIO_INTEGRAL: employee.SALARIO_INTEGRAL,
                VALOR_HORA: employee.SUELDO_EMPLEADO / 240,
                AUXILIO_TRANSPORTE_EMPLEADO: employee.AUXILIO_TRANSPORTE,
                USAR_NORMA_LEY_EMPLEADO: employee.USAR_NORMA_LEY,
                COTIZA_PENSION: employee.COTIZA_PENSION
            })
        }
    }

    handleSubmit = (event) => {
        event.preventDefault();
        this.setState({ show: true });
    }

    handleClose = () => {
        this.setState({ show: false });
    };

    addSalary = () => {
        const detail = {
            codigo_movimiento: "18",
            valor: this.state.SUELDO_EMPLEADO / 30 * this.state.TOTAL_TIEMPO_DEVENGADO,
            valor_total_linea: this.state.SUELDO_EMPLEADO / 30 * this.state.TOTAL_TIEMPO_DEVENGADO,
            cantidad: this.state.TOTAL_TIEMPO_DEVENGADO,
        }
        return detail;
    }
    addHealth = () => {
        const valor_salud = (this.state.SALARIO_INTEGRAL === "1") ? 0 : (this.state.SUELDO_EMPLEADO / 30) * this.state.TOTAL_TIEMPO_DEVENGADO * (this.state.PORCENTAJE_SALUD / 100);
        const detail = {
            codigo_movimiento: "20",
            valor: valor_salud / this.state.TOTAL_TIEMPO_DEVENGADO,
            valor_total_linea: valor_salud,
            cantidad: this.state.TOTAL_TIEMPO_DEVENGADO,
            percentage: this.state.PORCENTAJE_SALUD
        }
        return detail
    }

    addPension = () => {
        const valor_pension = (this.state.SALARIO_INTEGRAL === "1") ? 0 : (this.state.SUELDO_EMPLEADO / 30) * this.state.TOTAL_TIEMPO_DEVENGADO * (this.state.PORCENTAJE_PENSION / 100);

        const detail = {
            codigo_movimiento: "21",
            valor: valor_pension / this.state.TOTAL_TIEMPO_DEVENGADO,
            valor_total_linea: valor_pension,
            cantidad: this.state.TOTAL_TIEMPO_DEVENGADO,
            percentage: this.state.PORCENTAJE_PENSION,
        }
        return detail;
    }

    addAuxTransport = () => {
        const detail = {
            codigo_movimiento: "22",
            valor: this.state.AUX_TRANSPORTE / this.state.TOTAL_TIEMPO_DEVENGADO,
            valor_total_linea: this.state.AUX_TRANSPORTE / this.state.TOTAL_TIEMPO_DEVENGADO * this.state.TOTAL_TIEMPO_DEVENGADO,
            cantidad: this.state.TOTAL_TIEMPO_DEVENGADO,
            percentage: this.state.PORCENTAJE_PENSION,
        }
        return detail;
    }

    defaultDetail = () => {
        const valor_limite = this.state.VALOR_SMLV * 2;
        let validAuxTrans = false;

        // console.log(this.state.USAR_NORMA_LEY_EMPLEADO)
        // console.log(this.state.AUXILIO_TRANSPORTE_EMPLEADO)

        if (this.state.USAR_NORMA_LEY_EMPLEADO && this.state.SUELDO_EMPLEADO <= valor_limite) validAuxTrans = true;
        if (!this.state.USAR_NORMA_LEY_EMPLEADO && this.state.AUXILIO_TRANSPORTE_EMPLEADO) validAuxTrans = true;
        if (!this.state.USAR_NORMA_LEY_EMPLEADO && !this.state.AUXILIO_TRANSPORTE_EMPLEADO) validAuxTrans = false;

        // const totalDetail = []
        const { detalle_nomina } = this.state;
        const formatData = [];

        formatData.push(this.structureDetail(this.addSalary()))
        formatData.push(this.structureDetail(this.addHealth()))
        console.log('COTIZA_PENSION: ', this.state.COTIZA_PENSION)
        if (this.state.COTIZA_PENSION === '1' || this.state.COTIZA_PENSION === 1)
            formatData.push(this.structureDetail(this.addPension()))

        if (validAuxTrans)
            formatData.push(this.structureDetail(this.addAuxTransport()))
        if (formatData.length > 0) this.setState({ detalle_nomina: [...detalle_nomina, ...formatData] })
    }

    calcularTotales = (detalle) => {
        let dedu = 0;
        let deve = 0;
        let totalnomina = 0;

        detalle.forEach(element => {
            if (element.TIPO === 1) {
                if (element.VALOR_TOTAL_LINEA !== 0) {
                    deve += parseFloat(element.VALOR_TOTAL_LINEA);
                }
            } else if (element.TIPO === 2) {
                if (element.VALOR_TOTAL_LINEA !== 0) {
                    dedu += parseFloat(element.VALOR_TOTAL_LINEA);
                }
            }
        });
        totalnomina = (deve - dedu);
        return { DEDUCCIONES_TOTAL: dedu, DEVENGADOS_TOTAL: deve, COMPROBANTE_TOTAL: totalnomina };
    }

    enviarInfo = () => {
        this.setState({ show: false });
        // event.preventDefault();
        const detalle = this.state.detalle_nomina;
        const totales = this.calcularTotales(detalle);
        const fecha_periodo = new Date(this.initDateRef.current.value);
        fecha_periodo.setDate(fecha_periodo.getDate() + 1);
        const periodo = fecha_periodo.getFullYear().toString() + (fecha_periodo.getMonth() + 1).toString().padStart(2, '0')
        const cabecera = {
            ID_EMPRESA: this.state.ID_EMPRESA,
            TIPO_DOCUMENTO_NOMINA: this.state.TIPO_DOCUMENTO_NOMINA,
            ID_EMPLEADO: this.state.ID_EMPLEADO,
            DIRECCION_EMPRESA: this.state.DIRECCION_EMPRESA,
            TELEFONO_EMPRESA: periodo,
            NOMBRE_EMPLEADO: this.state.NOMBRE_EMPLEADO,
            DOCUMENTO_EMPLEADO: this.state.DOCUMENTO_EMPLEADO,
            DIRECCION_EMPLEADO: this.state.DIRECCION_EMPLEADO,
            CIUDAD_EMPLEADO: this.state.CIUDAD_EMPLEADO,
            BANCO_EMPLEADO: this.state.BANCO_EMPLEADO,
            TIPO_CUENTA_EMPLEADO: this.state.TIPO_CUENTA_EMPLEADO,
            NUMERO_CUENTA_EMPLEADO: this.state.NUMERO_CUENTA_EMPLEADO,
            INICIO_PERIODO: this.initDateRef.current.value,
            FIN_PERIODO: this.finalDateRef.current.value,
            TOTAL_DIAS_NOMINA: this.state.TOTAL_TIEMPO_DEVENGADO,
            FECHA_DOCUMENTO: this.state.fecha_hoy,
            DEVENGADOS_TOTAL: totales.DEVENGADOS_TOTAL,
            DEDUCCIONES_TOTAL: totales.DEDUCCIONES_TOTAL,
            COMPROBANTE_TOTAL: totales.COMPROBANTE_TOTAL,
            ID_TRANSACCION: "",
            DOCUMENTO_ENVIADO: 0,
            DOCUMENTO_ENVIADO_OBSERVACION: "",
            DOCUMENTO_RELACION: this.state.DOCUMENTO_RELACION,
            AJUSTE: this.state.AJUSTE

        }


        const doc_nomina = {
            cabecera,
            detalle
        }
        const datasend = {
            method: 'POST',
            body: JSON.stringify(doc_nomina),
            headers: {
                'Content-Type': 'application/json',
                'empresa': this.state.ID_EMPRESA,
                'tipo': this.state.tipo,
            }
        };
        fetch(config.servBackEnd + '/payroll/create', datasend).then(response => response.json())
            .then(data => {
                if (data.ok) {
                    const m = `El documento ${data.NUMERO_DOCUMENTO_NOMINA} ha sido creado satisfactoriamente.`
                    this.setState({ showAlert: true, variant: 'success', alertmessage: m });
                } else {
                    this.setState({ showAlert: true, variant: 'danger ', alertmessage: data.message });
                }
                window.scrollTo({
                    top: 0,
                    behavior: 'smooth'
                });
            });

        //setTimeout(window.location.reload(),4000);
    }

    updateDate = () => {
        const fecha_inicial = moment.utc(this.initDateRef.current.value, 'YYYY-MM-DD');
        const fecha_final = moment.utc(this.finalDateRef.current.value, 'YYYY-MM-DD');
        const diff = fecha_final.diff(fecha_inicial, 'days');
        let adicional = 1;

        if (fecha_final.isValid()) {
            const currentLastDate = moment.utc(this.finalDateRef.current.value, 'YYYY-MM-DD').endOf('month');
            const lastDayOfMonth = currentLastDate.date();

            if (lastDayOfMonth === 31) adicional = 0;
            if (currentLastDate.month() === 1 && lastDayOfMonth === currentLastDate.daysInMonth()) adicional = 30 - (lastDayOfMonth - 1);
        }

        const quantity_days = (diff) ? diff + adicional : 0;
        this.setState({ TOTAL_TIEMPO_DEVENGADO: quantity_days });
    }

    updateDetailPayroll = (data) => {
        const { detalle_nomina } = this.state;
        const formatData = this.structureDetail(data);
        if (formatData) this.setState({ detalle_nomina: [...detalle_nomina, formatData] })
    }

    structureDetail = (data) => {
        const { detalle_nomina } = this.state;
        const validDetail = detalle_nomina.findIndex((detail) => detail.CODIGO_MOVIMIENTO === data.codigo_movimiento)

        if (data.codigo_movimiento && validDetail === -1) {
            const infoConcept = concepts_payroll.find((concept) => concept.code === data.codigo_movimiento)
            const formatData = {
                ID_EMPRESA: this.currentCompany,
                TIPO_DOCUMENTO_NOMINA: this.state.TIPO_DOCUMENTO_NOMINA,
                ID_EMPLEADO: this.state.ID_EMPLEADO,
                NOMBRE_EMPLEADO: this.state.NOMBRE_EMPLEADO,
                DOCUMENTO_EMPLEADO: this.state.DOCUMENTO_EMPLEADO,
                VALOR: data.valor,
                DESCRIPCION_DEVEN_O_DEDUC: infoConcept.description,
                TIPO: infoConcept.type,
                VALOR_TOTAL_LINEA: data.valor_total_linea,
                CODIGO_MOVIMIENTO: data.codigo_movimiento,
                PORCENTAJE: (data.percentage || infoConcept.percentage),
                UNIDAD_TIEMPO: infoConcept.unit_time,
                TOTAL_TIEMPO_DEVEN: data.cantidad,
                PERIODO_INICIO: data.periodo_inicio,
                PERIODO_FIN: data.periodo_fin,
                TIPO_INCAPACIDAD: data.tipo_incapacidad,
                DES_OTRA_DEDUC: "",
            }
            return formatData;
        }
        return null;
    }

    removeitem = (index) => {
        let newDetail = this.state.detalle_nomina
        newDetail.splice(index, 1);
        this.setState({ detalle_nomina: newDetail })
    }

    render() {
        const { detalle_nomina, empleados, documentos, DOCUMENTO_EMPLEADO } = this.state;
        const mensajeConfirm = '¿Esta seguro que desea crear el documento de nómina?';
        const validacionUser = (this.state.tipo === '0' || this.state.tipo === '1');

        const { showAlert, variant, alertmessage } = this.state;
        const totales = this.calcularTotales(detalle_nomina)
        const isDefaulActive = (
            this.state.DOCUMENTO_EMPLEADO
            && this.state.TOTAL_TIEMPO_DEVENGADO
            && this.state.DOCUMENTO_EMPLEADO !== ''
            && this.state.TOTAL_TIEMPO_DEVENGADO !== ''
        )

        return (
            <div className="FormularioEmpresa">

                <div>
                    <ModalConfirm show={this.state.show} enviarInfo={this.enviarInfo} handleClose={this.handleClose} mensaje={mensajeConfirm} ></ModalConfirm>
                </div>
                <TitleModule text={'NÓMINA EMPLEADOS'} />
                {showAlert &&
                    <Alert variant={variant}>{alertmessage}</Alert>
                }
                {!validacionUser && <p>Usuario no valido para este modulo</p>}
                {validacionUser &&
                    <div>
                        <BackButton />
                        <Form className="form" onSubmit={this.handleSubmit} id='completePayroll'>
                            <Card bg={'light'} >
                                <Card.Header>
                                    <Nav variant="tabs" defaultActiveKey="#first">
                                        <Nav.Item>
                                            <Nav.Link href="#disabled" disabled>
                                                <h5>Informacion General</h5>
                                            </Nav.Link>
                                        </Nav.Item>
                                    </Nav>
                                </Card.Header>
                                <Card.Body>
                                    <Form.Row>
                                        <Form.Group as={Col}>
                                            <Form.Label>EMPLEADO</Form.Label>
                                            <SearchEmployee data={empleados} event={this.selectEmployee} style={{ width: 450 }}></SearchEmployee>
                                        </Form.Group>

                                        <Form.Group as={Col}>
                                            <Form.Label>DOCUMENTO</Form.Label>
                                            <Form.Control required name="DOCUMENTO_EMPLEADO" type="text" placeholder="Documento" value={this.state.DOCUMENTO_EMPLEADO} disabled ></Form.Control>
                                        </Form.Group>
                                    </Form.Row>
                                    <Form.Row>
                                        <Form.Group as={Col}>
                                            <Form.Label>FECHA INICIO</Form.Label>
                                            <Form.Control required ref={this.initDateRef} name="fecha_inicial" type="date" onChange={this.updateDate} id="periodo_fecha_inicial" />
                                        </Form.Group>
                                        <Form.Group as={Col}>
                                            <Form.Label>FECHA FIN</Form.Label>
                                            <Form.Control required ref={this.finalDateRef} name="fecha_final" type="date" onChange={this.updateDate} id="periodo_fecha_final" />
                                        </Form.Group>

                                        <Form.Group>
                                            <Form.Label>TOTAL DIAS TRABAJADOS</Form.Label>
                                            <Form.Control name="TOTAL_TIEMPO_DEVENGADO" type="number" value={this.state.TOTAL_TIEMPO_DEVENGADO} disabled />
                                        </Form.Group>
                                    </Form.Row>
                                    <Form.Row>
                                        <Form.Group as={Col}>
                                            <Form.Check
                                                label="ES AJUSTE"
                                                name="AJUSTE"
                                                type="checkbox"
                                                checked={this.state.AJUSTE}
                                                onChange={(e) => this.setState({ AJUSTE: e.target.checked })}
                                            />
                                            {/* <Form.Label>CONFIRMAR SI ES UN AJUSTE</Form.Label>
                                            <input type="Checkbox" onChange={(e) => this.setState({ AJUSTE: e.target.checked })} ></input> */}
                                        </Form.Group>
                                        {
                                            this.state.AJUSTE &&
                                            <Fragment>
                                                <Form.Group as={Col}>
                                                    <Form.Label>DOCUMENTO A RELACIONAR</Form.Label>
                                                </Form.Group>
                                                <Form.Group as={Col}>
                                                    <Form.Control required as="select" custom="true" onChange={(e) => this.setState({ DOCUMENTO_RELACION: e.target.value })} value={this.state.DOCUMENTO_RELACION}>
                                                        <option key='d' value="">--Seleccione Documento --</option>
                                                        {documentos.map(function (current, index) {
                                                            if (current.DOCUMENTO_EMPLEADO === DOCUMENTO_EMPLEADO) {
                                                                return <option key={'d' + index} value={current.TIPO_DOCUMENTO_NOMINA + current.NUMERO_DOCUMENTO_NOMINA} >{current.TIPO_DOCUMENTO_NOMINA + "-" + current.NUMERO_DOCUMENTO_NOMINA}</option>;
                                                            } else {
                                                                return null;
                                                            }

                                                        })}
                                                    </Form.Control>
                                                </Form.Group>
                                            </Fragment>
                                        }
                                    </Form.Row>
                                </Card.Body>
                            </Card>
                            <Card bg='light'>
                                <Card.Header>
                                    <Navbar className="bg-body-tertiary">
                                        <Container>
                                            <Navbar.Text><h5>Detalles Nomina</h5></Navbar.Text>
                                            <Navbar.Toggle />
                                            <Navbar.Collapse className="justify-content-end">
                                                <Navbar.Text>
                                                    {this.state.DOCUMENTO_EMPLEADO !== ''
                                                        ? <DetailPayrollModal returnInfo={this.updateDetailPayroll} valor_hora={this.state.VALOR_HORA} />
                                                        : <Button variant="success" disabled> Agregar Novedad</Button>
                                                    }
                                                    <Button className="ml-3" variant="info" disabled={!isDefaulActive} onClick={this.defaultDetail}>Detalles Por defecto</Button>
                                                </Navbar.Text>
                                            </Navbar.Collapse>
                                        </Container>
                                    </Navbar>
                                </Card.Header>
                                <Card.Body>
                                    <Row>
                                        <Col>
                                            <Table striped bordered hover >
                                                <thead>
                                                    <tr>
                                                        <th colSpan={5}>DEVENGADO</th>
                                                    </tr>
                                                    <tr>
                                                        <th></th>
                                                        <th>Descripcion</th>
                                                        <th>Cantidad</th>
                                                        <th>Valor</th>
                                                        <th>Total</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {detalle_nomina.map((detail, i) => {
                                                        if (detail.TIPO === 1) {
                                                            return (<tr key={i}>
                                                                <td>
                                                                    <IconContext.Provider value={{ size: "2em" }}>
                                                                        <IoIosRemoveCircle onClick={() => this.removeitem(i)} />
                                                                    </IconContext.Provider>
                                                                </td>
                                                                <td>{detail.DESCRIPCION_DEVEN_O_DEDUC}</td>
                                                                <td>{detail.TOTAL_TIEMPO_DEVEN}</td>
                                                                <td>{Intl.NumberFormat('es-MX').format(detail.VALOR)}</td>
                                                                <td>{Intl.NumberFormat('es-MX').format(detail.VALOR_TOTAL_LINEA)}</td>
                                                            </tr>)
                                                        } else {
                                                            return null;
                                                        }
                                                    })}
                                                </tbody>
                                                <tfoot>
                                                    <tr>
                                                        <td colSpan={4}>TOTAL DEVENGADO</td>
                                                        <td>{Intl.NumberFormat('es-MX').format(totales.DEVENGADOS_TOTAL)}</td>
                                                    </tr>
                                                </tfoot>
                                            </Table>
                                        </Col>
                                        <Col>
                                            <Table striped bordered hover >
                                                <thead>
                                                    <tr>
                                                        <th colSpan={5}>DEDUCCIONES</th>
                                                    </tr>
                                                    <tr>
                                                        <th></th>
                                                        <th>Descripcion</th>
                                                        <th>Cantidad</th>
                                                        <th>Valor</th>
                                                        <th>Total</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {detalle_nomina.map((detail, i) => {
                                                        if (detail.TIPO === 2) {
                                                            return (<tr key={i}>
                                                                <td>
                                                                    <IconContext.Provider value={{ size: "2em" }}>
                                                                        <IoIosRemoveCircle onClick={() => this.removeitem(i)} />
                                                                    </IconContext.Provider>
                                                                </td>
                                                                <td>{detail.DESCRIPCION_DEVEN_O_DEDUC}</td>
                                                                <td>{detail.TOTAL_TIEMPO_DEVEN}</td>
                                                                <td>{Intl.NumberFormat('es-MX').format(detail.VALOR)}</td>
                                                                <td>{Intl.NumberFormat('es-MX').format(detail.VALOR_TOTAL_LINEA)}</td>
                                                            </tr>)
                                                        } else {
                                                            return null;
                                                        }
                                                    })}
                                                </tbody>
                                                <tfoot>
                                                    <tr>
                                                        <td colSpan={4}>TOTAL DEDUCCIONES</td>
                                                        <td>{Intl.NumberFormat('es-MX').format(totales.DEDUCCIONES_TOTAL)}</td>
                                                    </tr>
                                                </tfoot>
                                            </Table>
                                        </Col>
                                    </Row>

                                </Card.Body>
                                <Card.Footer>
                                    <Row className="justify-content-md-center">
                                        <Col md="auto">TOTAL DOCUMENTO</Col>
                                        <Col md="auto">{Intl.NumberFormat('es-MX').format(totales.COMPROBANTE_TOTAL)}</Col>
                                    </Row>
                                </Card.Footer>
                            </Card>
                            <Button variant="primary" type="submit" form='completePayroll'>Guardar</Button>
                        </Form>

                    </div>
                }
                <Mensajes estado={this.state.mostrarMensaje} mensaje={this.state.mensaje} ocultar={() => this.setState({ mostrarMensaje: false })} ></Mensajes>
            </div >
        );
    }
}
export default (FormularioParametros);
//<-- disabled={!this.validateForm()} -->


// WEBPACK FOOTER //
// ./src/components/nomina/formularioPagoNomina.jsx